module.exports = __webpack_public_path__ + "img/contact-logo.bb6bd250.jpg";